import { useTranslation } from 'react-i18next';

export type PromotionType = keyof typeof PROMOTION_TYPE;

export const PROMOTION_TYPE = {
    REGULAR: 'REGULAR',
    DISCOUNTED: 'DISCOUNTED',
};

export const usePromotionType = () => {
    const { t } = useTranslation();
    return {
        REGULAR: t('TYPES.REGULAR'),
        DISCOUNTED: t('TYPES.DISCOUNTED'),
    };
};

export const PROMOTION_TYPE_COLOR: Record<
    string,
    'success' | 'error' | 'default' | 'primary' | 'secondary' | 'info' | 'warning'
> = {
    REGULAR: 'success',
    DISCOUNTED: 'warning',
};

export const useFilterSelectOptions = () => {
    const promotionTypes = usePromotionType();

    return Object.keys(promotionTypes).map((type) => ({
        value: type,
        label: promotionTypes[type],
    }));
};
